<div class="nav nav-pills flex-column flex-sm-row {{ themeCss }}">
    <ng-container *ngFor="let menuItem of menuItems">
        <button *ngIf="menuItem.id != 'general-settings'"
            [ngClass]="{ 'active': menuItem?.route ? menuItem.route === router.url.split('?')[0] : menuItem.active }"
            [routerLink]="menuItem?.route ?? []" (click)="menuClicked.emit(menuItem)"
            class="btn-styled btn-tab grotesk-regular {{ themeCss }} text-sm-center">
            {{ menuItem.title }}
        </button>
        <div *ngIf="menuItem.id == 'general-settings'"
            [ngClass]="{ 'active': menuItem?.route === router.url || menuItem.active }"
            routerLink="/settings/general-settings" appDropdown
            class="dropdown btn btn-styled btn-tab {{ themeCss }} text-sm-center">
            <div class="hover  btn-styled btn-tab {{ themeCss }} text-sm-center" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <span [ngClass]="{ 'active-tab':  menuItem.active }" class="grotesk-regular">
                    {{ menuItem.title }}
                </span>
                <svg-icon *ngIf="panelIsOpen" src="assets/images/call/up-arrow.svg"></svg-icon>
                <svg-icon *ngIf="!panelIsOpen" src="assets/images/call/down-arrow.svg"></svg-icon>
            </div>
            <div class="dropdown-menu dropdown-menu-end shadow-sm  g-0">
                <div *ngFor="let tab of tabs" (click)="setSelectedTab(tab.tabText)"
                    class="d-flex flex-column flex-grow-1 tab ">
                    <span [ngClass]="[tab.isSelected ? 'tab-selected' : '']"
                        class="dropdown-item text-primary tab-text grotesk-regular ">
                        {{ tab.tabText | titlecase }}
                    </span>
                    <div [ngClass]="[tab.isSelected ? 'active' : 'inactive']" class="tab-selector"></div>
                </div>
            </div>
        </div>
    </ng-container>
</div>